import { Box } from '@mui/material';
import React from 'react';
import DiscountChip from '../../../DiscountChip';

const SaleTitle = ({ sale, renderItemTitleWithOver }) => (
    <Box display='flex' flexDirection='row' alignItems='center' gap={0.5} flexWrap='wrap'>
        {renderItemTitleWithOver(sale)}
        <DiscountChip discountApplied={sale.discount_applied} size="small" showOfferName />
    </Box>
)

export default SaleTitle;
